import React, { useState, useRef } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DriverInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import moment from 'moment-timezone'
import TypeRoadTest from './TypeRoadTest'
import MasterNumber from './MasterNumber'
import DriverFirstName from './DriverFirstName'
import DriverLastName from './DriverLastName'
import DateOfBirth from './DateOfBirth'
import EmailAddress from './EmailAddress'
// import ConfirmEmailAddress from './ConfirmEmailAddress'
import PhoneNumber from './PhoneNumber'
import BackAnchor from '../../../../shared/components/BackAnchor'
var unidecode = require('unidecode')

const DriverInformationView = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [typeRoadTestValid, setTypeRoadTestValid] = useState('')
  const [masterNumberValid, setMasterNumberValid] = useState('')
  const [driverFirstNameValid, setDriverFirstNameValid] = useState('')
  const [driverLastNameValid, setDriverLastNameValid] = useState('')
  const [dateOfBirthValid, setDateOfBirthValid] = useState('')
  const [emailAddressValid, setEmailAddressValid] = useState('')
  // const [confirmEmailAddressValid, setConfirmEmailAddressValid] = useState('')
  const [phoneNumberValid, setPhoneNumberValid] = useState('')

  const [typeRoadTestError, setTypeRoadTestError] = useState('driver_information.type_of_road_test_error')
  const [masterNumberError, setMasterNumberError] = useState('driver_information.master_number_error')
  const [driverFirstNameError, setDriverFirstNameError] = useState('driver_information.driver_first_name_error')
  const [driverLastNameError, setDriverLastNameError] = useState('driver_information.driver_last_name_error')
  const [dateOfBirthError, setDateOfBirthError] = useState('driver_information.date_of_birth_error')
  const [emailAddressError, setEmailAddressError] = useState('driver_information.email_address_error')
  // const [confirmEmailAddressError, setConfirmEmailAddressError] = useState('driver_information.confirm_email_address_error')
  const [phoneNumberError, setPhoneNumberError] = useState('driver_information.phone_number_error')

  const dateOfBirthDayEl = useRef(null)
  const dateOfBirthMonthEl = useRef(null)
  const dateOfBirthYearEl = useRef(null)

  const typeRoadTest = useSelector((state) => state.driver.driverInformation.typeRoadTest)
  const masterNumber = useSelector((state) => state.driver.driverInformation.masterNumber)
  const driverFirstName = useSelector((state) => state.driver.driverInformation.driverFirstName)
  const driverLastName = useSelector((state) => state.driver.driverInformation.driverLastName)
  const dateOfBirth = useSelector((state) => state.driver.driverInformation.dateOfBirth)
  const emailAddress = useSelector((state) => state.driver.driverInformation.emailAddress)
  // const confirmEmailAddress = useSelector((state) => state.driver.driverInformation.confirmEmailAddress)
  const phoneNumber = useSelector((state) => state.driver.driverInformation.phoneNumber)
  const masterNumberDOB = useSelector((state) => state.driver.driverInformation.masterNumberDOB)

  const drivingSchoolName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.drivingSchoolName)

  const backNextProps = {
    prevText: t('driver_information.back'),
    prevURL:
      drivingSchoolName === '' ? `/${i18n.language}${t('routes.school_question')}` : `/${i18n.language}${t('routes.driving_school_info')}`,
    nextText: t('driver_information.next'),
  }

  const onNext = () => {
    try {
      if (validateFields()) {
        history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      validateTypeRoadTest(typeRoadTest)
      let masterValid = validateMasterNumber(masterNumber)
      validateDriverFirstName(driverFirstName)
      validateDriverLastName(driverLastName)
      validateDateOfBirth()
      validateEmailAddress(emailAddress)
      // validateConfirmEmail(confirmEmailAddress)
      validatePhoneNumber(phoneNumber)
      if (typeRoadTest === 'select') {
        setTypeRoadTestValid(false)
      }
      if (masterNumber === '') {
        setMasterNumberValid(false)
      }
      if (driverFirstName === '') {
        setDriverFirstNameValid(false)
      }
      if (driverLastName === '') {
        setDriverLastNameValid(false)
      }
      if (dateOfBirth === '' || dateOfBirth === '--') {
        setDateOfBirthValid(false)
      }
      if (emailAddress === '') {
        setEmailAddressValid(false)
      }
      // if (confirmEmailAddress === '') {
      //   setConfirmEmailAddressValid(false)
      // }
      if (phoneNumber === '') {
        setPhoneNumberValid(false)
      }
      return (
        typeRoadTestValid === true &&
        masterValid === true &&
        driverFirstNameValid === true &&
        driverLastNameValid === true &&
        dateOfBirthValid === true &&
        emailAddressValid === true &&
        phoneNumberValid === true &&
        typeRoadTest !== 'select' &&
        masterNumber !== '' &&
        driverFirstName !== '' &&
        driverLastName !== '' &&
        dateOfBirth !== '' &&
        dateOfBirth !== '--' &&
        emailAddress !== '' &&
        phoneNumber !== ''
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateTypeRoadTest = (testType) => {
    if (testType === '') {
      setTypeRoadTestValid(false)
      setTypeRoadTestError('driver_information.type_of_road_test_error')
    } else {
      setTypeRoadTestValid(true)
    }
  }

  const getParsedMasterNumber = () => {
    let number = ''
    let parsedLastName = driverLastName.replace(/[^a-zA-Z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]/g, '')
    if (driverLastName && driverLastName[0].toLocaleLowerCase() === 'm' && driverLastName[1].toLocaleLowerCase() === 'c') {
      number = 'MAC'
      number = number + (parsedLastName[2] === undefined ? ' ' : parsedLastName[2])
      number = number + (parsedLastName[3] === undefined ? ' ' : parsedLastName[3])
    } else {
      for (let i = 0; i < 5; i++) {
        number = number + (parsedLastName[i] === undefined ? ' ' : parsedLastName[i])
      }
    }
    number = number + masterNumberDOB
    return number
  }

  const validateMasterNumber = (masterNumberElem) => {
    if (driverLastName && driverLastName.length > 1 && masterNumberDOB && masterNumberDOB.length === 6) {
      const regex = RegExp(/^[a-zA-Z0-9 ]{14}$/i)
      if (masterNumberElem.length > 0) {
        let fixedMasterNumber = masterNumberElem.substring(0, 11)
        if (
          regex.test(masterNumberElem) &&
          !isNaN(masterNumberElem.substring(11)) &&
          fixedMasterNumber &&
          fixedMasterNumber.toLocaleLowerCase() === unidecode(getParsedMasterNumber().toLocaleLowerCase())
        ) {
          setMasterNumberValid(true)
          return true
        } else {
          setMasterNumberValid(false)
          setMasterNumberError('driver_information.master_number_error_invalid')
          return false
        }
      } else {
        setMasterNumberValid(false)
        setMasterNumberError('driver_information.master_number_error')
        return false
      }
    }
  }

  const validateDriverFirstName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          if (name.length > 1) {
            setDriverFirstNameValid(true)
          } else {
            setDriverFirstNameValid(false)
            setDriverFirstNameError('driver_information.driver_first_name_error_less_characters')
          }
        } else {
          setDriverFirstNameValid(false)
          setDriverFirstNameError('driver_information.driver_first_name_error_invalid')
        }
      } else {
        setDriverFirstNameValid(false)
        setDriverFirstNameError('driver_information.driver_first_name_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateDriverLastName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          if (name.length > 1) {
            setDriverLastNameValid(true)
          } else {
            setDriverLastNameValid(false)
            setDriverLastNameError('driver_information.driver_last_name_error_less_characters')
          }
        } else {
          setDriverLastNameValid(false)
          setDriverLastNameError('driver_information.driver_last_name_error_invalid')
        }
      } else {
        setDriverLastNameValid(false)
        setDriverLastNameError('driver_information.driver_last_name_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateDateOfBirth = () => {
    try {
      let dayRegex = RegExp(/^\d{2}$/)
      let monthRegex = RegExp(/^\d{2}$/)
      let yearRegex = RegExp(/^\d{4}$/)
      if (
        dayRegex.test(dateOfBirthDayEl.current.value) &&
        monthRegex.test(dateOfBirthMonthEl.current.value) &&
        yearRegex.test(dateOfBirthYearEl.current.value)
      ) {
        let inputDate = `${dateOfBirthYearEl.current.value}-${dateOfBirthMonthEl.current.value}-${dateOfBirthDayEl.current.value}`
        if (moment(inputDate).isValid()) {
          if (
            !moment(inputDate).isAfter(moment().format('YYYY-MM-DD'), 'day') &&
            !moment(inputDate).isAfter(moment().subtract(16, 'years').format('YYYY-MM-DD'), 'day')
          ) {
            setDateOfBirthValid(true)
          } else {
            setDateOfBirthValid(false)
            setDateOfBirthError('driver_information.date_of_birth_error_old_future')
          }
        } else {
          setDateOfBirthValid(false)
          setDateOfBirthError('driver_information.date_of_birth_error_invalid')
        }
      } else {
        setDateOfBirthValid(false)
        setDateOfBirthError('driver_information.date_of_birth_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateEmailAddress = (email) => {
    try {
      const regex = RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      if (email.length > 0) {
        if (regex.test(email)) {
          setEmailAddressValid(true)
        } else {
          setEmailAddressValid(false)
          setEmailAddressError('driver_information.email_address_error_invalid')
        }
      } else {
        setEmailAddressValid(false)
        setEmailAddressError('driver_information.email_address_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  // const validateConfirmEmail = (confirmEmail) => {
  //   try {
  //     if (confirmEmail === emailAddress) {
  //       setConfirmEmailAddressValid(true)
  //     } else {
  //       setConfirmEmailAddressValid(false)
  //       setConfirmEmailAddressError('driver_information.confirm_email_address_error')
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }

  const validatePhoneNumber = (number) => {
    try {
      if (number.length > 0) {
        if (number.length === 12) {
          setPhoneNumberValid(true)
        } else {
          setPhoneNumberValid(false)
          setPhoneNumberError('driver_information.phone_number_error_invalid')
        }
      } else {
        setPhoneNumberValid(false)
        setPhoneNumberError('driver_information.phone_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <BackAnchor />
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h2>{t('driver_information.tell_us_about')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <TypeRoadTest
            validateTypeRoadTest={validateTypeRoadTest}
            typeRoadTestError={typeRoadTestError}
            typeRoadTestValid={typeRoadTestValid}
            setIsError={setIsError}
          />
          <MasterNumber
            validateMasterNumber={validateMasterNumber}
            masterNumberError={masterNumberError}
            masterNumberValid={masterNumberValid}
            setIsError={setIsError}
          />
          <DriverFirstName
            validateDriverFirstName={validateDriverFirstName}
            driverFirstNameError={driverFirstNameError}
            driverFirstNameValid={driverFirstNameValid}
            setIsError={setIsError}
          />
          <DriverLastName
            validateDriverLastName={validateDriverLastName}
            validateMasterNumber={validateMasterNumber}
            driverLastNameError={driverLastNameError}
            driverLastNameValid={driverLastNameValid}
            setIsError={setIsError}
          />
          <DateOfBirth
            validateDateOfBirth={validateDateOfBirth}
            validateMasterNumber={validateMasterNumber}
            dateOfBirthValid={dateOfBirthValid}
            dateOfBirthError={dateOfBirthError}
            dateOfBirthDayEl={dateOfBirthDayEl}
            dateOfBirthMonthEl={dateOfBirthMonthEl}
            dateOfBirthYearEl={dateOfBirthYearEl}
            setIsError={setIsError}
          />
          <EmailAddress
            validateEmailAddress={validateEmailAddress}
            emailAddressError={emailAddressError}
            emailAddressValid={emailAddressValid}
            setIsError={setIsError}
          />
          {/* <ConfirmEmailAddress
            validateConfirmEmail={validateConfirmEmail}
            confirmEmailAddressError={confirmEmailAddressError}
            confirmEmailAddressValid={confirmEmailAddressValid}
            setIsError={setIsError}
          /> */}
          <PhoneNumber
            validatePhoneNumber={validatePhoneNumber}
            phoneNumberError={phoneNumberError}
            phoneNumberValid={phoneNumberValid}
            setIsError={setIsError}
          />
        </div>
      </div>
      <div className={styles['back_next_margin']}>
        <BackNextButtons props={backNextProps} nextOnClick={onNext} />
      </div>
    </div>
  )
}

export default withTranslation('common')(DriverInformationView)
